import {
  MDBAlert,
  MDBBadge,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBCardFooter,
  MDBCardHeader,
  MDBCheckbox,
  MDBCol,
  MDBIcon,
  MDBInput,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalHeader,
  MDBModalTitle,
  MDBNavbarItem,
  MDBPopconfirm,
  MDBPopconfirmMessage,
  MDBProgress,
  MDBProgressBar,
  MDBRow,
  MDBScrollbar,
  MDBSelect
} from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DarkMode from "../DarkMode/DarkMode";
import Logo from "../images/StreamsAIWhite.png";
import LogoDark from "../images/StreamsAI.png";
// import UploadStatusIndicator from "./UploadStatusIndicator.jsx";


// import AudioPlayer from "../mediaplayers/AudioPlayer";
import { auth_signOut_url, show_links_tab } from "../../apiclients/apiurls";
import { checkUploadStatus, saveAskLunaView, setGlobalLocationFilter, signOut } from "../../apiclients/streamsapi_bridge";
import BlackMode from "../NightMode/BlackTheme";
import { defaultUImg } from "../images";
import { ai_icon } from "../../ai-chat-buddy/assets/images";
import ChatBotView from "../../ai-chat-buddy/features/chatbot/components/ChatBotView.tsx";
import { useDispatch } from "react-redux";
import { setTypingMessageEffect } from "../../ai-chat-buddy/features/chatbot/store/ChatBotStore.ts";
// import { ProfilePictureUploader } from "../ProfilePictureUploader.js";
import { useAdminContext } from "../adminstore/Admin-Context.jsx";
import { customSearch, useAutoFocusSearchAfterLoads } from "../CustomSearchUtil/CustomSearch.js";
import ImportUser from "../editviews/user/ImportUser.js";

function Header(props) {
  const [message, setMessage] = useState(null);
  const [emessage, setEMessage] = useState(null);
  const [mmessage, setMMessage] = useState(null);
  const [showLP, setShowLP] = useState(false);
  // const [adminuser, setAdminuser] = useState(null);
  const { t, i18n } = useTranslation();
  const [LocationSelectedIds, setLocationSelectedIds] = useState([]);
  const [pickedLanguage, setPickedLanguage] = useState("united-kingdom");
  const [open, setOpen] = useState(props.isopen || false);
  const dispatch = useDispatch();

  console.log("Header props isopen:", props.isopen, "open state:", open);

  // console.log("In headr location :::: " + JSON.stringify(globalLoc));
  // console.log("In headr selection :::: " + JSON.stringify(selectedlocation));
  const [selectValue, setSelectValue] = useState([]);
  const [selectData, setSelectData] = useState([]);
  const [displayData, setDisplayData] = useState([]);
  const [searchMainValue, setsearchMainValue] = useState("");
  const [existLocationSelectIds, setexistLocationSelectIds] = useState([]);
  // const existSelect = selectedlocation;
  const [issave, setIsSave] = useState(false);
  const [allLocation, setallLocation] = useState(false);
  const [loginEmail, setloginEmail] = useState("");
  const [locationnames, setlocationnames] = useState("");
  const [resetValue, setresetValue] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [profilePic, setprofilePic] = useState(null);
  const [statusPercentage, setstatusPercentage] = useState("0");
  const [impStatus, setimpStatus] = useState(0);
  const [actualReposne, setactualReposne] = useState("0");
  const [statusType, setstatusType] = useState(-1);
  const [uploaderOpen, setUploaderOpen] = useState(false);
  const [firstRequest, setfirstRequest] = useState(false);
  const [importUser, setimportUser] = useState(false);
  const importuserToggle = () => setimportUser(!importUser);
  const [isLoading, setisLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
  useAutoFocusSearchAfterLoads(dataLoaded, setDataLoaded, searchRef, true)

  // const importUsers = sessionStorage.getItem("user_imported");
  const handleCircleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    // sessionStorage.removeItem("user_imported");
    if (statusPercentage === "100" && impStatus !== 2 && impStatus !== 3) {
      window.location.href = "/userlanding";
      return;
    }
    setfirstRequest(true);
    importuserToggle();
  };

  useEffect(() => {
    // if (importUsers) {
    uploadSheetStatus();
    // }

  }, []);

  async function uploadSheetStatus() {
    try {
      const response = await checkUploadStatus(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
      // const isImported = sessionStorage.getItem("user_imported");
      const statusData = await response.json();
      console.log(" ::::::::::::::: Polling Status ::::::::::::::::::", JSON.stringify(statusData));
      // setsheetstatus(statusData?.status ?? -1);
      if (((statusData.status === 1 || statusData.status === 4 || statusData.status === 6 || statusData.status === 7))) {
        const statusPercentage = statusData.percentage ?? "0";
        setactualReposne(statusPercentage);
        if (
          typeof statusPercentage === "string" &&
          statusPercentage.includes("/")
        ) {
          const [current, total] = statusPercentage
            .split("/")
            .map((s) => parseInt(s.trim(), 10));
          const progress = (current / total) * 100;

          setstatusPercentage(Math.round(progress));
          setTimeout(() => {
            uploadSheetStatus();
          }, 3000);

        }



      } else if (statusData.status === 5 || statusData.status === 2 || statusData.status === 3) {
        setimpStatus(statusData.status);
        setstatusPercentage("100");
      } else {

      }


    } catch (error) {
      console.error("Error while polling:", error);
      // setstatusPercentage("0");
    }

  }

  const handleImageUpdate = ({ imageData, serverResponse }) => {
    setprofilePic(imageData);
    console.log('Server response:', serverResponse);
  };



  /*useEffect(() => {
    sessionStorage.setItem("chatbotOpen", open);
    if (open) {
      if (sessionStorage.getItem("chatbotDocked") === "true") {
        saveAskLunaView({
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          asklunaview: 2,
        });
      } else {
        saveAskLunaView({
          siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
          asklunaview: 1,
        });
      }
    } else {
      saveAskLunaView({
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        asklunaview: 0,
      });
    }
  }, [open]);*/


  useEffect(() => {
    if (resetValue || !isOpen) {
      const globalLoc = sessionStorage.getItem("global_location") ?
        JSON.parse(sessionStorage.getItem("global_location")) :
        [];
      const selectedlocation = sessionStorage.getItem("global_select_location") ?
        JSON.parse(sessionStorage.getItem("global_select_location")) :
        [];

      const modifiedLocs = globalLoc && globalLoc.filter(loc => loc.value !== -1);
      setSelectData(modifiedLocs);
      setDisplayData(modifiedLocs);
      const isAllSelected = selectedlocation.some(locid => locid === -1);
      const selectedlocids = isAllSelected ? modifiedLocs.map(loc => loc.value) : [...selectedlocation];
      setLocationSelectedIds(selectedlocids);
      setexistLocationSelectIds(selectedlocids);
      if (isAllSelected) {
        setallLocation(true);
        setlocationnames("All Locations")
      } else {
        setallLocation(false);
        setlocationnames(modifiedLocs.filter(locs => selectedlocation.includes(locs.value)).map(loc => loc.text).join(", "));
      }
      setSelectValue(selectedlocation);
      setresetValue(false);
    }

  }, [resetValue, isOpen]);

  useEffect(() => {
    // Location-->All Location Drop Down in header autoFocus issue fix
    console.log("selectData selectData ", selectData)
    console.log("isOpen isOpen", isOpen)
    if (isOpen && selectData.length > 0 && !dataLoaded) {
      setTimeout(() => {
        setDataLoaded(true);
      }, 0);
    }
  }, [selectData, isOpen]);





  const streamsReq =
    JSON.parse(sessionStorage.getItem("admin_session"))?.isStreamReq ?? 0;
  function checkSession() {
    let validSession = false;
    if (sessionStorage.getItem("admin_session")) {
      validSession = true;
      // setAdminuser(
      //   JSON.parse(sessionStorage.getItem("admin_session"))?.company_name ?? ""
      // );
      setprofilePic(JSON.parse(sessionStorage.getItem("admin_session"))?.profile_pic_link ?? "");
      setloginEmail(
        JSON.parse(sessionStorage.getItem("admin_session")).mailId
      );
    }
    if (!validSession) {
      window.location.href = "/login";
    }
    if (localStorage.getItem("s_message")) {
      setMessage(localStorage.getItem("s_message"));
      setTimeout(() => {
        setMessage(null);
        localStorage.removeItem("s_message");
      }, 5000);
    }
    if (localStorage.getItem("b_message")) {
      setMessage(localStorage.getItem("b_message"));
      setTimeout(() => {
        setMessage(null);
        localStorage.removeItem("b_message");
      }, 12000);
    }
    if (localStorage.getItem("f_message")) {
      setEMessage(localStorage.getItem("f_message"));
      setTimeout(() => {
        setEMessage(null);
        localStorage.removeItem("f_message");
      }, 5000);
    }
    if (localStorage.getItem("m_message")) {
      setMMessage(localStorage.getItem("m_message"));
      setTimeout(() => {
        setMMessage(null);
        localStorage.removeItem("m_message");
      }, 5000);
    }
  }
  useEffect(() => {
    localStorage.setItem("selectedTheme", "blue");
    checkSession();
  }, []);

  function goToPage(e, tview) {
    window.location.href = tview;
  }
  function setLang(e, tlang) {
    setPickedLanguage(tlang);
  }

  const [modal1, setModal1] = useState(false);
  const toggleModal1 = () => setModal1(!modal1);
  function toggleLeftPanel(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!showLP) {
      setShowLP(true);
      if (props.onToggleLP) props.onToggleLP(true);
    } else {
      setShowLP(false);
      if (props.onToggleLP) props.onToggleLP(false);
    }
  }

  function logoutAdmin(e) {
    //sending the request to api for application signout.
    Promise.resolve(signOut());
    sessionStorage.removeItem("admin_session");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("refreshtoken");
    localStorage.removeItem("admin_session");
    window.location.href = auth_signOut_url;
  }

  // Define a state variable to track the visibility of the chatbot
  const [isChatbotVisible, setChatbotVisibility] = useState(false);

  // Function to toggle the chatbot visibility
  const toggleChatbot = () => {
    setChatbotVisibility(!isChatbotVisible);
    setActive(!isActive);
  };
  // Function to toggle the chatbot visibility


  const closeChatbot = () => {
    setChatbotVisibility(false);
    setActive(!isActive);// Hide the chatbot when the close icon is clicked
  };

  const [isActive, setActive] = useState(false);
  const [isActive1, setActive1] = useState(false);


  const [isNotificationVisible, setNotificationVisible] = useState(false);

  const toggleNotifications = () => {
    setNotificationVisible(!isNotificationVisible);
    setActive1(!isActive1);
  }

  const closeNotification = () => {
    setNotificationVisible(false);
    setActive1(!isActive1);// Hide the chatbot when the close icon is clicked
  };

  const toggleDropdownMenu = () => {
    setIsDropDownVisible(!isDropDownVisible);
  };

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropDownVisible(false);
      setIsThemeOptionsVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  const [isThemeOptionsVisible, setIsThemeOptionsVisible] = useState(false);
  const [isDropDownVisible, setIsDropDownVisible] = useState(false);
  const dropdownRef = useRef(null);

  // const toggleDropdownMenu = () => {
  //   setIsDropDownVisible(!isDropDownVisible);
  //   // Hide the theme options when closing the dropdown menu
  //   setIsThemeOptionsVisible(false);
  // };

  const toggleThemeOptions = () => {
    setIsThemeOptionsVisible(!isThemeOptionsVisible);
  };

  const closeDropdownMenu = () => {
    setIsDropDownVisible(false);
    setIsThemeOptionsVisible(false);
    window.location.reload();
  };

  const [isActiveLabel, setActiveLabel] = useState("false");
  const ToggleClass = () => {
    setActiveLabel(!isActiveLabel);
  };
  const [mainLinks, setMainLinks] = useState([
    {
      tabid: 1,
      icon: "home",
      action: "home",
      label: "Home",
    },
    {
      tabid: 7,
      icon: "locations",
      action: "LocLanding",
      label: "Locations",
    },

    {
      tabid: 3,
      icon: "users_icon",
      action: "userlanding",
      label: "Users",
    },
    {
      tabid: 2,
      icon: "Phone_system",
      action: "huntgroup",
      label: "Phone System",
    },
    {
      tabid: 6,
      icon: "admin_tools",
      action: "admintoolslanding",
      label: "Admin Tools",
    },
    {
      tabid: 5,
      icon: "billing",
      action: "billinglanding",
      label: "Billing",
    },
    {
      tabid: 4,
      icon: "analytics",
      action: "analyticslanding",
      label: "Analytics",
    },
  ]);

  const handleClick = async (event, selectValue) => {
    event.preventDefault();
    let filteredValue = [...selectValue];
    console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    const loggedinUser = JSON.parse(adminSession).logined_user;
    let isAllSelected = selectValue.length === selectData.length;
    if (isAllSelected) {
      filteredValue = [-1];

    }
    let update = {
      reqid: 62,
      siteid: siteid,
      filter_value: filteredValue,
      filter_type: 2,
      filter_key: 3,
      module_type: 1,
    }
    // if (loggedinUser.indexOf("@") !== -1) {
    //   update.agentid = loggedinUser;
    // }
    console.log("Modify location filter value  :::: " + JSON.stringify(update));
    let saverep = await setGlobalLocationFilter(update);
    console.log(`reponse of Edit user :::: ${JSON.stringify(saverep)}`);
    let saverepeMsg = await saverep.json();
    console.log(
      "response of modified data :::" + JSON.stringify(saverepeMsg)
    );
    if (saverepeMsg.status && saverepeMsg.status == "success") {
      // const matchFound = selectValue.includes(-1);
      let updateselect = [];
      if (isAllSelected) {
        updateselect = [-1];
        setSelectValue(updateselect);
        setlocationnames("All Locations");
      } else {
        updateselect = [...selectValue];
        setlocationnames(selectData.filter(locs => updateselect.includes(locs.value)).map(loc => loc.text).join(", "));
      }

      sessionStorage.setItem("global_select_location", JSON.stringify(updateselect));
      localStorage.setItem("s_message", saverepeMsg.message);
      sessionStorage.setItem("global_location_changed", true);
      const currentLink = sessionStorage.getItem("current_link");
      if (currentLink) {
        window.location.href = currentLink
      }
    }
    else {
      localStorage.setItem("f_message", saverepeMsg.message);
    }
  }

  // const handleOnchange = (value) => {
  //   const updateList = value.map(loc => loc.value);
  //   if (updateList.length !== existSelect.length && updateList.length > 0) {
  //     setIsSave(true);
  //   } else {
  //     const sortedList1 = updateList.slice().sort();
  //     const sortedList2 = existSelect.slice().sort();
  //     const ismatch = sortedList1.every((item, index) => item === sortedList2[index]);
  //     if (!ismatch) {
  //       setIsSave(true);
  //     } else {
  //       setIsSave(false);
  //     }
  //   }
  //   setSelectValue(updateList);
  //   console.log("value is :::::::: " + JSON.stringify(value.map(loc => loc.value)));

  // }

  // let loctitle = globalLoc.filter(obj => (selectValue.length > 0 && selectValue.includes(obj.value)));

  function handleSearch(e) {
    const value = e.target.value;
    setsearchMainValue(value);
    // setDisplayData(selectData.filter((Location) =>Location.text.toLowerCase().split(" ").some((word) => word.startsWith(value.toLowerCase()))));    
    setDisplayData(customSearch(selectData, value, ['text']))

  }

  function handleAllLocation(e) {
    // e.preventDefault();
    setallLocation(e.target.checked);
    if (e.target.checked) {
      const locId = displayData.map(loc => loc.value);
      setLocationSelectedIds(locId);
    } else {
      setLocationSelectedIds([]);
    }

  }

  const handleFilterCheckboxChange = (value) => {
    const updatedValues = [...LocationSelectedIds];
    if (updatedValues.includes(value)) {
      // If already selected, remove it
      updatedValues.splice(updatedValues.indexOf(value), 1);
    } else {
      // If not selected, add it
      updatedValues.push(value);
    }
    if (updatedValues.length !== displayData.length) {
      setallLocation(false);
    } else {
      const tempArray = displayData.map(loc => loc.value);
      const sortedArr1 = [...tempArray].sort();
      const sortedArr2 = [...updatedValues].sort();

      // Compare each element
      for (let i = 0; i < sortedArr1.length; i++) {
        if (sortedArr1[i] !== sortedArr2[i]) {
          setallLocation(false);
          break;
        }
      }
      setallLocation(true);
    }
    setLocationSelectedIds(updatedValues);
  };

  function isArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }

    // Sort both arrays
    const sortedArr1 = [...arr1].sort();
    const sortedArr2 = [...arr2].sort();

    // Compare each element
    for (let i = 0; i < sortedArr1.length; i++) {
      if (sortedArr1[i] !== sortedArr2[i]) {
        return false;
      }
    }

    return true;

  }

  // const handleSubmit = async (event, selectValue) => {
  //   event.preventDefault();
  //   let filteredValue = [...selectValue];
  //   console.log("value of selected filters are ::::: " + JSON.stringify(selectValue));
  //   const adminSession = sessionStorage.getItem("admin_session");
  //   const siteid = JSON.parse(adminSession).siteid;
  //   if (selectValue.length === filterLocationList.length) {
  //     filteredValue = [-1];

  //   }
  //   let update = {
  //     reqid: 62,
  //     siteid: siteid,
  //     filter_value: filteredValue,
  //     filter_type: 1,
  //     filter_key: 3,
  //     module_type: 3,
  //   }
  //   // if (loggedinUser.indexOf("@") !== -1) {
  //   //   update.agentid = loggedinUser;
  //   // }
  //   console.log("Modify Location user filter value  :::: " + JSON.stringify(update));
  //   let saverep = await setGlobalLocationFilter(update);
  //   console.log(`reponse of Edit Location user :::: ${JSON.stringify(saverep)}`);
  //   let saverepeMsg = await saverep.json();
  //   console.log(
  //     "response of modified Location user data :::" + JSON.stringify(saverepeMsg)
  //   );
  //   if (saverepeMsg.status && saverepeMsg.status == "success") {
  //     localStorage.setItem("s_message", saverepeMsg.message);
  //     // sessionStorage.removeItem('userLocationFilter');
  //     navigate("/userlanding", {
  //       state: { tab: "suser", tab2: "sloc" },
  //     });
  //     window.location.reload();
  //   }
  //   else {
  //     localStorage.setItem("f_message", saverepeMsg.message);
  //   }
  // }

  function handleOnClose() {
    setresetValue(true);

  }

  function cancelfilterChanges(flag) {
    setLocationSelectedIds(existLocationSelectIds);
    setIsOpen(!isOpen);  // Toggle the state when clicked
    if (existLocationSelectIds.length === selectData.length || existLocationSelectIds.length === displayData.length) {
      setallLocation(true);
    } else {
      setallLocation(false);
    }

  }



  const toggleFilterOptions = () => {

    setIsOpen(prevState => !prevState);
  };


  // const [themeBasedLogo, setThemeBasedLogo] = useState(localStorage.getItem("selectedColorTheme"))
  // console.log(themeBasedLogo, "themeBasedLogo")
  // useEffect(() => {
  //   if (themeBasedLogo === "system") {
  //     const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  //     if (systemPrefersDark) {
  //       setThemeBasedLogo("dark")
  //     }
  //     else {
  //       setThemeBasedLogo(localStorage.getItem("selectedColorTheme"));
  //     }
  //     console.log(systemPrefersDark, "systemPrefersDark")
  //   }
  // }, [themeBasedLogo])


  const getInitialTheme = () => {
    let savedTheme = localStorage.getItem("selectedColorTheme");

    if (!savedTheme) {
      // Save "system" as default if nothing is stored
      localStorage.setItem("selectedColorTheme", "system");
      savedTheme = "system";
    }

    if (savedTheme === "system") {
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      return systemPrefersDark ? "dark" : "light";
    }

    return savedTheme;
  };

  const [themeBasedLogo, setThemeBasedLogo] = useState(getInitialTheme);

  useEffect(() => {
    const savedTheme = localStorage.getItem("selectedColorTheme");

    if (savedTheme === "system") {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

      const handler = (e) => {
        setThemeBasedLogo(e.matches ? "dark" : "light");
      };

      // Initial setup for current system preference
      setThemeBasedLogo(mediaQuery.matches ? "dark" : "light");

      mediaQuery.addEventListener('change', handler);

      return () => {
        mediaQuery.removeEventListener('change', handler);
      };
    } else {
      // Not "system", apply selected theme directly
      setThemeBasedLogo(savedTheme);
    }
  }, []);





  const emojiPickerRef = useRef(null);


  useEffect(() => {

    const handleClickOutside = (event) => {

      if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {

        setIsOpen(false);
      }
    };

    const handleKeyDown = (event) => {

      if (event.key === 'Escape') {

        setIsOpen(false);
      }
    };

    document.removeEventListener('mousedown', handleClickOutside);
    document.removeEventListener('keydown', handleKeyDown);

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKeyDown);


  }, [emojiPickerRef]);

  const handleToggle = () => {
    dispatch(setTypingMessageEffect(false)); // <- Set typing effect to false when Add Lna button is clicked
    setOpen(!open);
    saveAskLunaView({
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      asklunaview: open ? 0 : 1, // Toggle between 0 and 1
    });
    props.setOpenDocked(open ? false : true); // Update the AL view state
  };
  useEffect(() => {
    setOpen(props.isopen);
  }, [props.isopen]);


  const sessioncompanyName = sessionStorage.getItem("admin_session") &&
    sessionStorage.getItem("admin_session") &&
    JSON.parse(sessionStorage.getItem("admin_session"))?.companyName
    ? JSON.parse(sessionStorage.getItem("admin_session")).companyName
    : "";
  // const modifyCompanyName = sessionStorage.getItem("modify_company_name");
  const companyname = sessioncompanyName;

  const logoPath = sessionStorage.getItem("admin_session") && JSON.parse(sessionStorage.getItem("admin_session"))?.streamsLogo;
  const adminuser = JSON.parse(sessionStorage.getItem("admin_session"))?.company_name ?? ""


  return (
    <>

      <div className="MobileNotSupport">
        <div className="position-fixed top-0 w-100 nav-Header ">
          <a className="navbar-brand p-3" href="/home">
            {/* <i className="logo"></i> */}
            <img src={logoPath ? logoPath : (themeBasedLogo == "dark" ? Logo : LogoDark)} className="logo" alt="" />
          </a>
        </div>
        {/* <div className="d-flex flex-column align-items-center justify-content-center w-80">
          <MDBIcon fas icon="ban" className="Block-Icon" />
          <h4 className="text-center mt-4">
            Streams Admin is not-supported on mobile phones.
          </h4>
          <p className="text-secondary text-center">Try again from a different Desktop/ipad/Tablet device.</p>
        </div> */}
      </div>
      {/* <ChatBot /> */}
      <DarkMode />
      {/* <SaveChanges /> */}

      {message && (
        <MDBAlert
          open
          className="alert-center"
          color="success"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{message}</span>
        </MDBAlert>
      )}
      {emessage && (
        <MDBAlert
          open
          className="alert-center"
          color="danger"
          autohide
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-check-circle me-3"></i>
          <span className="alert-msg">{emessage}</span>
        </MDBAlert>
      )}
      {mmessage && (
        <MDBAlert
          open
          className="alert-center alert-mixed"
          autohide
          color="warning"
          position="bottom-right"
          delay={10000}
        >
          <i className="fas fa-circle me-3"></i>
          <span className="alert-msg">{mmessage}</span>
        </MDBAlert>
      )}
      <nav
        id="main-navbar"
        className="navbar navbar-expand-lg navbar-light bg-white fixed-top"
      >
        <div className="container-fluid mainheadheight">
          <a className="navbar-brand" href="/home">
            {/* <i className="logo"></i> */}
            <img src={logoPath ? logoPath : (themeBasedLogo == "dark" ? Logo : LogoDark)} className="logo" alt="" />
          </a>
          <button
            onClick={(e) => toggleLeftPanel(e)}
            data-mdb-toggle="sidenav"
            data-mdb-target="#sidenav-2"
            className="btn btn-toggle btn-secondary btn-floating toggle menu-toggle mob-block"
            aria-controls="#sidenav-2"
            aria-haspopup="true"
          >Sub Menu
            {/* {mainLinks.map((key) => (
            <>
              {props.active ? key.label * 1 : key.label}
            </>
          ))} */}
            <i className="fas fa-bars"></i>
          </button>


          <p className="px-3 vertical-lines me-3">
            {companyname}
          </p>




          {streamsReq === 0 && (
            <form>
              <div className="headerFilter">
                <div onClick={toggleFilterOptions} className="w-100">
                  <p className='filterElliipse' style={{ width: "200px" }} title={locationnames} >
                    {locationnames}
                  </p>
                </div>
                <span class="select-arrow"></span>



                <div className={`headerFilterReasult headerFilterReasultAnimation shadow-3 ${isOpen ? 'slideDown' : ''}`} ref={emojiPickerRef}>
                  <div className="p-2">
                    <MDBInput ref={searchRef} placeholder="search" type="text" size="sm" value={searchMainValue} onChange={(e) => handleSearch(e)} />
                  </div>
                  <div class="select-option select-all-option">
                    <MDBCheckbox name="flexCheck" checked={allLocation} onChange={(e) => handleAllLocation(e)} label="All Locations" />
                  </div>
                  {/* <div className="filter-border"></div> */}
                  <div className="filtersScroll">
                    {displayData && displayData.map((Location) => (
                      <div class="select-option select-all-option">
                        <MDBCheckbox name='flexCheck' value={Location.value} id={Location.value} label={Location.text} checked={LocationSelectedIds.includes(Location.value)}
                          onChange={() => handleFilterCheckboxChange(Location.value)}
                        />
                      </div>
                    ))}
                  </div>
                  <div className="d-flex float-end">
                    {(LocationSelectedIds.length > 0 && !isArraysEqual(LocationSelectedIds, existLocationSelectIds)) && (
                      <>
                        <div class="select-custom-content">
                          <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(1)}>Cancel</MDBBtn>
                          <MDBBtn size="sm" className="ms-2" onClick={(e) => handleClick(e, LocationSelectedIds)}> Apply</MDBBtn>
                        </div>
                      </>
                    )}
                  </div>
                </div>



              </div>

            </form>
          )}



          {/* {streamsReq === 0 && (
            <form className="d-md-flex input-group w-auto my-auto"> */}
          {/* <MDBSelect selectAll={false}
              multiple
              search
              noResultLabel='No Results Found'
              optionsSelectedLabel='Locations selected'
              data={selectData}
              value={selectValue}
              onChange={(value) => {
                handleOnchange(value);
              }}
              title={loctitle.length > 0 ? loctitle.map(obj => obj.text) : ""}
            >
              {issave && (
                <MDBBtn size='sm' onClick={(e) => handleClick(e)}>Save</MDBBtn>
              )}
            
            </MDBSelect> */}





          {/* 
              <div className="mt-1 noBg" style={{ backgroundColor: "#FFF" }}>
                <MDBPopconfirm className="p-0 w-auto" color='light' placement='bottom-start' onClick={(e) => e.preventDefault()} rippleColor="#FFFFFF" btnChildren={<>
                  <p className='filterElliipse' style={{ width: "250px" }}>
                    {locationnames}
                  </p>
                </>}>

                  <MDBPopconfirmMessage className="p-2 border rounded-2">
                    <div className="d-flex align-items-center">
                      <div className="w-100">
                        <MDBInput placeholder="search" value={searchMainValue} onChange={(e) => handleSearch(e)} />
                      </div>
                    </div>
                    <div className="filter-border py-2"></div>
                    <div className="mt-3">
                      <MDBCheckbox checked={allLocation} onChange={(e) => handleAllLocation(e)} label="All Locations" />
                    </div>
                    <div className="filtersScroll">
                      {displayData && displayData.map((Location) => (
                        <MDBCheckbox name='flexCheck' value={Location.value} id={Location.value} label={Location.text} checked={LocationSelectedIds.includes(Location.value)}
                          onChange={() => handleFilterCheckboxChange(Location.value)}
                        />

                      ))}
                      <div className="filter-border"></div>
                    </div>
                    <div className="d-flex float-end mt-3">
                      {(LocationSelectedIds.length > 0 && !isArraysEqual(LocationSelectedIds, existLocationSelectIds)) && (
                        <>
                          <MDBBtn size="sm" color="secondary" onClick={(e) => cancelfilterChanges(1)}>Cancel</MDBBtn>
                          <MDBBtn size="sm" className="ms-2" onClick={(e) => handleClick(e, LocationSelectedIds)}> Apply</MDBBtn>
                        </>
                      )}
                    </div>
                  </MDBPopconfirmMessage>
                </MDBPopconfirm>
              </div> */}










          {/*             
            <AudioPlayer file="https://file-examples.com/storage/fee472ce6e64b122ba0c8b3/2017/11/file_example_MP3_700KB.mp3"/> */}
          {/* </form>
          )} */}

          {/* impStatus === 2 ?  "Validation Failed" : impStatus === 3 ? "Validation Success" */}


          <ul className="navbar-nav ms-auto d-flex flex-row align-items-center">
            {statusPercentage !== "0" && (
              <div onClick={(e) => handleCircleClick(e)}>
                <div className="cursor-pointer progress-bar-container" style={{ width: "200px" }}>
                  <div>
                    <p className={`${statusPercentage === "100"  ? impStatus === 2 || impStatus === 3 ? "text-primary" :"text-success" : "text-primary"} fw-bold mb-0 lh-normal d-flex align-items-end`}>
                      {statusPercentage === "100" ? impStatus === 2 || impStatus === 3 ? "User import in progress" : "Completed" : "Processing Users"}
                      {statusPercentage === "100" && (impStatus === 2 || impStatus === 3) ? 
                                            <div 
                                            className="animation-wrapper">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      :
                      
                      (impStatus !== 2 && impStatus !== 3 && statusPercentage === "100") && <MDBIcon fas icon="check-circle" className="ms-2" color="success" />}
                    </p>
                  </div>
                  {impStatus !== 2 && impStatus !== 3 &&
                    <div className="d-flex align-items-center mt-1">
                      <div className="w-100">
                        <MDBProgress>
                          <MDBProgressBar bgColor={statusPercentage === "100" ? "success" : ""} striped={statusPercentage === "100" ? false : true} animated width={statusPercentage} valuemin={0} valuemax={100} />
                        </MDBProgress>
                      </div>
                      <span className="text-muted ms-2 lh-normal">{statusPercentage}%</span>
                    </div>
                  }
                </div>
              </div>
            )}

            <button className="luna-button" onClick={handleToggle}>
              <img src={ai_icon} width={28} className="me-2" />
              Ask Luna
            </button>




            <MDBNavbarItem ref={dropdownRef}>
              <div className="profile__picture" onClick={toggleDropdownMenu}>
                <img
                  src={profilePic && profilePic !== "" ? profilePic : defaultUImg}
                  alt=""
                  style={{
                    width: "40px",
                    height: "40px",
                  }}
                  className="rounded-circle border me-2"
                />
              </div>
              {isDropDownVisible && (
                <div className="navBar__DropDown shadow-4">
                  {/* Dropdown content */}
                  <div className="option__main nav_header_dropdown_options">
                    <div className="">
                      <img
                        src={profilePic && profilePic !== "" ? profilePic : defaultUImg}
                        alt=""
                        style={{
                          width: "40px",
                          height: "40px",
                        }}
                        className="rounded-circle border me-2"
                      />
                    </div>
                    <div className="nav_header_dropdown_options">
                      <h6 className="m-0">
                        <strong>{adminuser}</strong>
                        <p className="o">{loginEmail}</p>
                      </h6>
                    </div>
                  </div>
                  <hr className="border my-1" />
                  <div className="nav_header_dropdown_options">
                    <div className="switch-theme p-3 py-2 nav-link" onClick={toggleThemeOptions}>
                      <MDBIcon fas icon="adjust" className="me-2" />
                      <span>Switch Theme </span>
                      <span className="float-end mt-2px">
                        <MDBIcon fas icon="angle-right" />
                      </span>
                    </div>
                    {isThemeOptionsVisible && (
                      <div className="theme-options shadow-4" onClick={closeDropdownMenu}>
                        <BlackMode className="me-2" />
                      </div>
                    )}
                  </div>
                  {/* {show_links_tab == 1 &&
                  <hr className="border my-1" />
                    <div className="nav_header_dropdown_options">
                      <div className="p-3 py-2 nav-link switch-theme">
                        <MDBIcon fas icon="globe" className="fas fs-6 me-2 fa-sign-in" />Language
                      </div>
                    </div>} */}

                  <hr className="border my-1" />
                  <div className="nav_header_dropdown_options">
                    <div className="p-3 py-2 nav-link switch-theme" onClick={(e) => logoutAdmin(e)} >
                      <i className="fas fs-6 me-2 fa-sign-in"></i>Sign out
                    </div>
                  </div>
                </div>
              )}
            </MDBNavbarItem>
          </ul>
        </div >
      </nav >
      <MDBModal open={modal1} setShow={setModal1} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent className="popup-width">
            <MDBModalHeader>
              <MDBModalTitle className="modal-title">
                {t("911comp")}
              </MDBModalTitle>
              <MDBBtn
                className="btn-close"
                color="none"
                onClick={toggleModal1}
              ></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              All devices look good for 911. Thanks for checking!
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal
        open={importUser}
        onClose={() => setimportUser(false)}
        nonInvasive
      >
        <MDBModalDialog size="fullscreen">
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Import User Template</MDBModalTitle>
              {/* <MDBBtn className='btn-close' color='none' onClick={importuserToggle}></MDBBtn> */}
            </MDBModalHeader>
            <MDBModalBody className="pb-0">
              <ImportUser
                onClose={importuserToggle}
                setIsloading={setisLoading}
                onShow={setimportUser}
                show={importUser}
                firstRequest={firstRequest}
                setfirstRequest={setfirstRequest}
              />
            </MDBModalBody>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
      <div id="topMessage"></div>

      <ChatBotView open={open} setOpen={setOpen} setTDocked={props.setDocked} setTOpenDocked={props.setOpenDocked} />
    </>
  );
}

export default Header; 
